import BasicLayout from '@/views/layout/BasicLayout'
// 生成一个只有 auth-view 的组件作为路由跳转的地方
const RouteView = {
  name: 'RouteView',
  render: (h) => h('router-view'),
}

export const asyncRouterMap = [
  {
    path: '/',
    name: 'root',
    component: BasicLayout,
    meta: { title: '基础模版' },
    children: [
      // 用户中心
      {
        path: '/admin_center',
        name: 'admin',
        redirect: '/admin_center/base',
        component: RouteView,
        meta: { title: '个人中心', subTitle: '个人数据统计汇总' },
        children: [
          {
            path: '/admin_center/base',
            name: 'adminBase',
            component: () => import('@/views/admin/CenterBase'),
            meta: { title: '个人中心', subTitle: '个人中心' },
          },
        ],
      },
      // 个人设置
      {
        path: '/admin_setting',
        name: 'setting',
        redirect: '/admin_setting/base',
        component: () => import('@/views/admin/Setting'),
        meta: {
          title: '个人设置',
          subTitle: '基础设置,安全设置,个性化设置,账户绑定,新消息通知',
        },
        children: [
          {
            path: '/admin_setting/base',
            name: 'settingBase',
            component: () => import('@/views/admin/SettingBase'),
            meta: { title: '基本信息', subTitle: '修改用户基本信息' },
          },
          {
            path: '/admin_setting/password',
            name: 'settingPassword',
            component: () => import('@/views/admin/SettingPassword'),
            meta: { title: '修改密码', subTitle: '用户修改密码' },
          },
          {
            path: '/admin_setting/addAdmin',
            name: 'settingAddAdmin',
            component: () => import('@/views/admin/SettingAddAdmin'),
            meta: { title: '添加推广员', subTitle: '添加推广员' },
          },
        ],
      },
      // auth 权限管理
      {
        path: '/auth',
        name: 'auth',
        redirect: '/auth/role',
        component: RouteView,
        meta: { title: '权限管理', subTitle: '权限管理' },
        children: [
          {
            path: '/auth/role',
            name: 'authRole',
            component: () => import('@/views/auth/Role'),
            meta: {
              title: '角色组',
              subTitle: '设置角色组,可访问的菜单和功能',
            },
          },
          {
            path: '/auth/role/modify',
            name: 'authRoleModify',
            component: () => import('@/views/auth/RoleModify'),
            meta: { title: '添加/修改 角色组' },
          },
          {
            path: '/auth/menu',
            name: 'authMenu',
            component: () => import('@/views/auth/Menu'),
            meta: { title: '菜单规则', subTitle: '设置目录菜单,开发时使用' },
          },
          {
            path: '/auth/user',
            name: 'authUser',
            component: () => import('@/views/auth/User'),
            meta: {
              title: '用户管理',
              subTitle: '用户管理',
            },
          },
          {
            path: '/auth/area',
            name: 'Area',
            component: () => import('@/views/auth/Area'),
            meta: { title: '地区管理', subTitle: '设置用户管理的地市或分校' },
          },
          {
            path: '/category/type',
            name: 'categoryIndex',
            component: () => import('@/views/category/Index'),
            meta: { title: '分类数据管理', subTitle: '管理分类数据' },
          },
        ],
      },
      // 小程序管理
      {
        path: '/program',
        name: 'program',
        redirect: '/program/setting',
        component: RouteView,
        meta: { title: '权限管理', subTitle: '权限管理' },
        children: [
          {
            path: '/program/setting',
            name: 'Setting',
            component: () => import('@/views/program/Setting'),
            meta: { title: '小程序管理', subTitle: '创建管理小程序活动' },
          },
          {
            path: '/program/detail',
            name: 'Detail',
            redirect: '/program/detail/member',
            component: () => import('@/views/program/Detail'),
            meta: { title: '小程序详情', subTitle: '小程序详情' },
            children: [
              {
                path: '/program/detail/statistical',
                name: 'DetailStatistical',
                component: () => import('@/views/program/DetailStatistical'),
                meta: { title: '数据展示', subTitle: '数据展示' },
              },
              {
                path: '/program/detail/page',
                name: 'DetailPage',
                component: () => import('@/views/program/DetailPage'),
                meta: {
                  title: '设置推广页面',
                  subTitle: '生成推广码时所需的推广页面',
                },
              },
              {
                path: '/program/detail/member',
                name: 'DetailMember',
                component: () => import('@/views/program/DetailMember'),
                meta: { title: '推广成员', subTitle: '推广成员' },
              },
              {
                path: '/program/detail/modify',
                name: 'DetailModify',
                component: () => import('@/views/program/DetailModify'),
                meta: { title: '成员添加', subTitle: '推广成员添加' },
              },
              {
                path: '/program/detail/template',
                name: 'DetailTemplate',
                component: () => import('@/views/program/DetailTemplate'),
                meta: {
                  title: '小程序公告模版',
                  subTitle: '小程序模版消息管理',
                },
              },
              {
                path: '/program/detail/message',
                name: 'DetailMessage',
                component: () => import('@/views/program/DetailMessage'),
                meta: { title: '公告发布', subTitle: '公告发布,预约' },
              },
              {
                path: '/program/detail/client',
                name: 'DetailClient',
                component: () => import('@/views/program/DetailClient'),
                meta: {
                  title: '客户信息',
                  subTitle: '推广员收集的客户信息汇总',
                },
              },
            ],
          },
        ],
      },
      // 自定义小程序
      {
        path: '/auto',
        name: 'auto',
        redirect: '/auto/rule',
        component: RouteView,
        meta: { title: '自定义小程序' },
        children: [
          {
            path: '/auto/table',
            name: 'autoTable',
            component: () => import('@/views/auto/Table'),
            meta: { title: '新建数据表单', subTitle: '数据表单' },
          },
          {
            path: '/auto/table/field',
            name: 'autoTableField',
            component: () => import('@/views/auto/TableField'),
            meta: { title: '数据字段', subTitle: '数据字段' },
          },
          {
            path: '/auto/table/data',
            name: 'autoTableData',
            component: () => import('@/views/auto/TableData'),
            meta: { title: '数据字典', subTitle: '数据字典' },
          },
          {
            path: '/auto/rule',
            name: 'autoRule',
            component: () => import('@/views/auto/Rule'),
            meta: { title: '自定义小程序', subTitle: '自定义小程序规则汇总' },
          },
          // 生成小程序
          {
            path: '/auto/modify',
            name: 'autoModify',
            component: () => import('@/views/auto/Modify'),
            meta: { title: '自定义小程序', subTitle: '自定义小程序规则' },
          },
          // 创建小程序用户
          {
            path: '/auto/member',
            name: 'autoMember',
            component: () => import('@/views/auto/Member'),
            meta: { title: '自定义小程序', subTitle: '推广员生成' },
          },
          {
            path: '/auto/member/list',
            name: 'autoMemberList',
            component: () => import('@/views/auto/MemberList'),
            meta: { title: '自定义小程序', subTitle: '推广员列表' },
          },
          {
            path: '/auto/collection',
            name: 'autoCollection',
            component: () => import('@/views/auto/Collection'),
            meta: { title: '自定义小程序', subTitle: '收集信息列表' },
          },
        ],
      },
      // 公众号管理
      {
        path: '/blog',
        name: 'blog',
        redirect: '/blog/setting',
        component: RouteView,
        meta: { title: '公众号', subTitle: '公众号列表' },
        children: [
          {
            path: '/blog/word',
            name: 'blogWord',
            component: () => import('@/views/blog/Word'),
            meta: { title: '关键词管理', subTitle: '关键词管理' },
          },
          {
            path: '/blog/setting',
            name: 'blogSetting',
            component: () => import('@/views/blog/Setting'),
            meta: { title: '公众号', subTitle: '公众号列表' },
          },
          {
            path: '/blog/detail',
            name: 'blogDetail',
            redirect: '/blog/detail/month',
            component: () => import('@/views/blog/Detail'),
            meta: { title: '公众号详情', subTitle: '公众号详情' },
            children: [
              {
                path: '/blog/detail/month',
                name: 'blogDetailMonth',
                component: () => import('@/views/blog/DetailMonth'),
                meta: { title: '公众号详情', subTitle: '月报' },
              },
              {
                path: '/blog/detail/daily',
                name: 'blogDetailDaily',
                component: () => import('@/views/blog/DetailDaily'),
                meta: { title: '公众号详情', subTitle: '日报' },
              },
            ],
          },
        ],
      },
      // 抖音管理
      {
        path: '/tik',
        name: 'tik',
        redirect: '/tik/setting',
        component: RouteView,
        meta: { title: '抖音管理' },
        children: [
          {
            path: '/tik/setting',
            name: 'tikSetting',
            component: () => import('@/views/tik/Setting'),
            meta: { title: '抖音数据管理' },
          },
          {
            path: '/tik/detail',
            name: 'tikDetail',
            redirect: '/tik/detail/data',
            component: () => import('@/views/tik/Detail'),
            meta: { title: '账号详情' },
            children: [
              {
                path: '/tik/detail/data',
                name: 'tikDetailData',
                component: () => import('@/views/tik/DetailData'),
                meta: { title: '抖音数据管理' },
              },
            ],
          },
        ],
      },
      // 白皮书功能
      {
        path: '/book',
        name: 'book',
        redirect: '/book/material',
        component: RouteView,
        meta: { title: '白皮书', subTitle: '白皮书' },
        children: [
          {
            path: '/book/material',
            name: 'bookMaterial',
            component: () => import('@/views/book/Material'),
            meta: { title: '资料管理', subTitle: '白皮书资料管理' },
          },
          {
            path: '/book/package',
            name: 'bookPackage',
            component: () => import('@/views/book/Package'),
            meta: { title: '资料包管理' },
          },
          {
            path: '/book/package/add',
            name: 'bookPackageAdd',
            component: () => import('@/views/book/PackageAdd'),
            meta: { title: '资料包创建' },
          },
          {
            path: '/book/activity',
            name: 'bookActivity',
            component: () => import('@/views/book/Activity'),
            meta: { title: '活动管理', subTitle: '白皮书活动管理' },
          },
          {
            path: '/book/detail',
            name: 'bookDetail',
            redirect: '/book/detail/add',
            component: () => import('@/views/book/Detail'),
            meta: { title: '活动详情', subTitle: '白皮书活动详情' },
            children: [
              {
                path: '/book/detail/add',
                name: 'bookDetailAdd',
                component: () => import('@/views/book/DetailAdd'),
                meta: { title: '添加推广员', subTitle: '添加推广员' },
              },
              {
                path: '/book/detail/member',
                name: 'bookDetailUser',
                component: () => import('@/views/book/DetailMember'),
                meta: { title: '推广员列表', subTitle: '添加推广员' },
              },
              {
                path: '/book/detail/info',
                name: 'bookDetailInfo',
                component: () => import('@/views/book/DetailInfo'),
                meta: { title: '推广数据表单', subTitle: '推广数据表' },
              },
            ],
          },
          {
            path: '/book/user',
            name: 'bookUser',
            component: () => import('@/views/book/User'),
            meta: { title: '小程序管理', subTitle: '创建管理小程序活动' },
          },
        ],
      },
      // QQ社群管理功能
      {
        path: '/qq',
        name: 'qq',
        redirect: '/qq/setting',
        component: RouteView,
        meta: { title: 'qq社群管理', subTitle: 'qq社群管理' },
        children: [
          {
            path: '/qq/setting',
            name: 'qqSetting',
            component: () => import('@/views/qq/Setting'),
            meta: { title: 'QQ社群', subTitle: '社群列表' },
          },
          {
            path: '/qq/exercise',
            name: 'qqExercise',
            component: () => import('@/views/qq/Exercise'),
            meta: { title: '带题模块', subTitle: '题集管理' },
          },
          {
            path: '/qq/manager',
            name: 'qqManager',
            component: () => import('@/views/qq/Manager'),
            meta: { title: '负责人绑定', subTitle: '负责人绑定' },
          },
          {
            path: '/qq/detail',
            name: 'qqDetail',
            component: () => import('@/views/qq/Detail'),
            redirect: '/qq/detail/member',
            meta: { title: '群详情', subTitle: '群设置中心' },
            children: [
              {
                path: '/qq/detail/member',
                name: 'qqDetailMember',
                component: () => import('@/views/qq/DetailMember'),
                meta: { title: '成员列表', subTitle: '成员列表分类' },
              },
            ],
          },
          {
            path: '/qq/my_group',
            name: 'qqMyGroup',
            component: () => import('@/views/qq/MyGroup'),
            meta: { title: '负责的群', subTitle: '负责的群' },
          },
          {
            path: '/qq/robot',
            name: 'qqRobot',
            component: () => import('@/views/qq/Robot'),
            meta: { title: '机器人管理', subTitle: 'QQ 机器人状态' },
          },
        ],
      },
      // 退费管理
      {
        path: '/refund',
        name: 'refund',
        redirect: '/refund/index',
        component: RouteView,
        meta: { title: '退费管理', subTitle: '退费管理' },
        children: [
          {
            path: '/refund/index',
            name: 'refundIndex',
            component: () => import('@/views/refund/Index'),
            meta: { title: '退费管理', subTitle: '退费管理' },
          },
        ],
      },
      // 上传图片
      {
        path: '/ftp',
        name: 'ftp',
        component: () => import('@/views/ftp/Index'),
        meta: { title: '上传文件管理' },
      },
      // 编辑器菜单
      {
        path: '/editors',
        name: 'editors',
        redirect: '/editors/material',
        component: RouteView,
        meta: { title: '微信公众号编辑器' },
        children: [
          {
            path: '/editors/material',
            name: 'editorsMaterial',
            component: () => import('@/views/editor/Material'),
            meta: { title: '素材管理', subTitle: '微信公众号素材管理' },
          },
          {
            path: '/editors/add',
            name: 'editorsAdd',
            component: () => import('@/views/editor/Add'),
            meta: { title: '素材添加/修改' },
          },
          {
            path: '/editors/draft',
            name: 'editorsDraft',
            component: () => import('@/views/editor/Draft'),
            meta: { title: '素材管理', subTitle: '微信公众号素材管理' },
          },
        ],
      },
      // 小工具
      {
        path: '/tool',
        name: 'tools',
        redirect: '/tool/index',
        component: RouteView,
        meta: { title: '小工具' },
        children: [
          {
            path: '/tool/index',
            name: 'toolIndex',
            component: () => import('@/views/tool/Index'),
            meta: { title: '所有小工具' },
          },
          {
            path: '/tool/standard_excel',
            name: 'ToolStandardExcel',
            component: () => import('@/views/tool/ToolStandardExcel'),
            meta: {
              title: 'Excel转化工具',
              subTitle: '活动名单转化为按照地市分类的名单',
            },
          },
          {
            path: '/tool/qq_group_excel',
            name: 'ToolQqGroupExcel',
            component: () => import('@/views/tool/QqGroupExcel'),
            meta: { title: 'Qq群导出', subTitle: 'Qq群导出' },
          },
        ],
      },
      // 文档编辑
      {
        path: '/md',
        name: 'md',
        redirect: '/md/edit',
        component: RouteView,
        meta: { title: '小工具' },
        children: [
          {
            path: '/md/edit',
            name: 'md_edit',
            component: () => import('@/views/md/MdEdit'),
            meta: { title: '文档编辑' },
          },
          {
            path: '/md/read',
            name: 'md_read',
            component: () => import('@/views/md/MdRead'),
            meta: {
              title: '文档阅读',
              subTitle: '活动名单转化为按照地市分类的名单',
            },
          },
          {
            path: '/md/all_md',
            name: 'md_all_md',
            component: () => import('@/views/md/AllMd'),
            meta: {
              title: '文档阅读',
              subTitle: '活动名单转化为按照地市分类的名单',
            },
          },
        ],
      },
      // 平台文档
      {
        path: '/log',
        component: RouteView,
        children: [
          {
            path: '/log',
            name: 'logIndex',
            component: () => import('@/views/log/Index'),
            meta: { title: '平台文档' },
          },
        ],
      },
      // 意见收集
      {
        path: '/suggest',
        component: RouteView,
        children: [
          {
            path: '/suggest',
            name: 'suggest',
            component: () => import('@/views/suggest/Index'),
            meta: { title: '意见提交' },
          },
        ],
      },
    ],
  },
  {
    path: '/qq/data_center',
    name: 'qqDataCenter',
    component: () => import('@/views/qq/DataCenter'),
    meta: { title: '社群数据大屏', subTitle: '社群数据大屏' },
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true,
  },
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: RouteView,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: '/user/login',
        name: 'login',
        mate: { title: '登陆' },
        component: () => import('@/views/Login'),
      },
    ],
  },
  {
    path: '/404',
    name: 'page404',
    mate: { title: '404 ! (⊙o⊙)哦 ~' },
    component: () => import('@/views/exception/404'),
  },
  {
    path: '/500',
    name: 'page500',
    mate: { title: '500 请刷新或联系网管' },
    component: () => import('@/views/exception/500'),
  },
  {
    path: '/editor',
    name: 'editor',
    mate: { title: 'editor' },
    component: () => import('@/views/editor/Index'),
  },
]
